import { atom } from "recoil";

const userDataState = atom({
  key: "userDataState",
  default: null,
});

export default userDataState;
